var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "pripady-table-container-wrapper" } },
    [
      _c("message-box", {
        attrs: {
          title: "Zrušiť prípad",
          text: "Naozaj chcete zrušiť tento prípad?",
          action: _vm.cancelPripad,
          persistent: "",
          "yes-no": ""
        },
        model: {
          value: _vm.warningMessage.open,
          callback: function($$v) {
            _vm.$set(_vm.warningMessage, "open", $$v)
          },
          expression: "warningMessage.open"
        }
      }),
      _c(
        "v-container",
        { staticClass: "pa-0", attrs: { id: "pripady-table-wrapper" } },
        [
          _c("v-data-table", {
            ref: "vDataTable",
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              "hide-default-footer": "",
              page: _vm.page,
              "items-per-page": 9,
              "single-select": false,
              "single-expand": false,
              expanded: _vm.expanded,
              "item-key": "cislo_obch_pripadu",
              loading: _vm.loading,
              loadingText: "Načítavam dáta ..."
            },
            on: {
              "update:page": function($event) {
                _vm.page = $event
              },
              "page-count": function($event) {
                _vm.pageCount = $event
              },
              "update:expanded": function($event) {
                _vm.expanded = $event
              },
              "click:row": _vm.rowClicked,
              "item-expanded": _vm.itemExpanded
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.id_stavu",
                  fn: function(ref) {
                    var item = ref.item
                    return [_c("status", { attrs: { state: item.id_stavu } })]
                  }
                },
                {
                  key: "item.najomca",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text-overflow-dots" }, [
                        _vm._v(_vm._s(item.najomca))
                      ])
                    ]
                  }
                },
                {
                  key: "item.rozpracovany_flag",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " + _vm._s(item.rozpracovany_flag ? "Áno" : "") + " "
                      )
                    ]
                  }
                },
                {
                  key: "item.datum_vytvorenia",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.datum_vytvorenia
                              ? item.datum_vytvorenia.formatDate()
                              : ""
                          ) +
                          " "
                      )
                    ]
                  }
                },
                {
                  key: "item.datum_modifikacie",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.datum_modifikacie
                              ? item.datum_modifikacie.formatDate()
                              : ""
                          ) +
                          " "
                      )
                    ]
                  }
                },
                {
                  key: "expanded-item",
                  fn: function(ref) {
                    var headers = ref.headers
                    var item = ref.item
                    return [
                      _c(
                        "td",
                        {
                          class: {
                            "ma-0 pa-0": true,
                            "expanded-closing": !_vm.transitioned[
                              _vm.getItemId(item)
                            ]
                          },
                          staticStyle: { height: "auto" },
                          attrs: { colspan: headers.length }
                        },
                        [
                          _c("v-expand-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.transitioned[_vm.getItemId(item)],
                                    expression: "transitioned[getItemId(item)]"
                                  }
                                ]
                              },
                              [
                                _c("v-data-table", {
                                  key: _vm.renderKey,
                                  attrs: {
                                    id: "table-predmety",
                                    "disable-pagination": true,
                                    "hide-default-footer": "",
                                    headers: _vm.predmety.headers,
                                    items: item.predmety,
                                    loading: item.loading,
                                    loadingText: "Načítavam dáta ..."
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "item.typ",
                                        fn: function(ref) {
                                          var item = ref.item
                                          return [
                                            _vm._v(
                                              " " + _vm._s(item.typ) + " "
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    item.typ_predmetu_sufix
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          ]
                                        }
                                      },
                                      {
                                        key: "item.oc",
                                        fn: function(ref) {
                                          var item = ref.item
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.oc
                                                    ? item.oc.toEurString()
                                                    : null
                                                ) +
                                                " "
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "item.akcie",
                                        fn: function(ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  "content-class":
                                                    "pripady-table-menu",
                                                  transition:
                                                    "slide-x-transition",
                                                  "offset-x": "",
                                                  left: "",
                                                  "close-delay": "100"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  dark: "",
                                                                  icon: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.loadMenuPredmetSettings(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              "v-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "mdi-dots-vertical"
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value: item.openMenu,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "openMenu",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.openMenu"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-list",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "pripady-table-menu-list",
                                                      elevation: "1"
                                                    }
                                                  },
                                                  _vm._l(item.menu, function(
                                                    m,
                                                    i
                                                  ) {
                                                    return _c(
                                                      "v-list-item",
                                                      {
                                                        key: i,
                                                        class: m.color,
                                                        attrs: {
                                                          link: "",
                                                          dense: "",
                                                          disabled: !m.isEnabled
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.actionClick(
                                                              m,
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-icon",
                                                          {
                                                            staticClass: "mr-4"
                                                          },
                                                          [
                                                            _c("v-icon", {
                                                              staticClass:
                                                                "material-icons-outlined icon-block",
                                                              attrs: {
                                                                size: "24"
                                                              },
                                                              domProps: {
                                                                textContent: _vm._s(
                                                                  m.icon
                                                                )
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(m.nazov)
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ]
                  }
                },
                {
                  key: "item.akcie",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "content-class": "pripady-table-menu",
                            transition: "slide-x-transition",
                            "offset-x": "",
                            left: "",
                            "close-delay": "100"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._b(
                                        {
                                          attrs: { dark: "", icon: "" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.loadMenuPripadSettings(
                                                item
                                              )
                                            }
                                          }
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-dots-vertical")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.openMenu,
                            callback: function($$v) {
                              _vm.$set(item, "openMenu", $$v)
                            },
                            expression: "item.openMenu"
                          }
                        },
                        [
                          _c(
                            "v-list",
                            {
                              attrs: {
                                id: "pripady-table-menu-list",
                                elevation: "1"
                              }
                            },
                            _vm._l(item.menu, function(m, i) {
                              return _c(
                                "v-list-item",
                                {
                                  key: i,
                                  class: m.color,
                                  attrs: {
                                    link: "",
                                    dense: "",
                                    disabled: !m.isEnabled
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.actionClick(m, item)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    { staticClass: "mr-4" },
                                    [
                                      _c("v-icon", {
                                        staticClass:
                                          "material-icons-outlined icon-block",
                                        attrs: { size: "24" },
                                        domProps: {
                                          textContent: _vm._s(m.icon)
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(m.nazov))
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.selected,
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          }),
          _c("v-pagination", {
            staticClass: "table-nav",
            attrs: { length: _vm.pageCount },
            model: {
              value: _vm.page,
              callback: function($$v) {
                _vm.page = $$v
              },
              expression: "page"
            }
          }),
          _c(
            "v-dialog",
            {
              attrs: {
                "overlay-color": "#000",
                "overlay-opacity": "0.66",
                persistent: "",
                eager: "",
                "max-width": "500"
              },
              model: {
                value: _vm.zmenaStrediskaDialog.open,
                callback: function($$v) {
                  _vm.$set(_vm.zmenaStrediskaDialog, "open", $$v)
                },
                expression: "zmenaStrediskaDialog.open"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "d-flex justify-space-between" },
                    [
                      _c("span", { staticClass: "gs100 f16" }, [
                        _vm._v("Zmena lokality pobočky")
                      ]),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              _vm.zmenaStrediskaDialog.open = false
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "f16 white100" },
                    [
                      _c("v-combobox", {
                        staticClass: "dynamic-input-control",
                        attrs: {
                          label: "Predajca",
                          "append-icon": "mdi-chevron-down",
                          outlined: "",
                          items: _vm.strediska,
                          loading: _vm.zmenaStrediskaDialog.loading,
                          "item-text": "display_member",
                          "item-value": "value_member",
                          "return-object": ""
                        },
                        model: {
                          value: _vm.zmenaStrediskaDialog.value,
                          callback: function($$v) {
                            _vm.$set(_vm.zmenaStrediskaDialog, "value", $$v)
                          },
                          expression: "zmenaStrediskaDialog.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-secondary",
                          on: {
                            click: function($event) {
                              _vm.zmenaStrediskaDialog.open = false
                            }
                          }
                        },
                        [_vm._v(" Zrušiť ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-primary",
                          on: {
                            click: function($event) {
                              return _vm.saveStredisko()
                            }
                          }
                        },
                        [_vm._v(" Zmeniť ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }